import { render } from "./ImprestCheifAccountantList.vue?vue&type=template&id=55d222d0"
import script from "./ImprestCheifAccountantList.vue?vue&type=script&lang=js"
export * from "./ImprestCheifAccountantList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__